import React from "react";
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { Link } from "react-router-dom"; //Link
 


const LabCard = ({ lab }) => {
  return (
    <div className="lab-card-new">
      <div className="lab-header" style={{backgroundColor: lab.bgColor,}}>
        <img src={lab.logo} alt={lab.name} className="lab-logo"/>
      </div>

      <div className="lab-body">
        <div className="lab-feature">
           <DescriptionOutlinedIcon />
           <span>No specific preparation required</span>
        </div>
        <div className="lab-feature">
            <DescriptionOutlinedIcon />
            <span> Earliest reports in 10-12 hours</span>
        </div>
      </div>
      <button className="book-btn-new">
         <Link to={lab.link}>
             Book Now
          </Link>
      </button>
    </div>
  );
};

export default LabCard;